module.exports = __webpack_public_path__ + "media/images/uvigo_logo-1127733cec94e17559370f435e1f6d17.svg";